import React from 'react';

var Bag = function Bag(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "Bag"), /*#__PURE__*/React.createElement("path", {
    d: "M4.718 9.5l1.4 8.166c.082.482.506.834 1.001.834h9.762c.495 0 .919-.352 1.001-.834l1.4-8.166H4.718zM8 7.5a4 4 0 1 1 8 0h4.484c.628 0 1.106.556 1.002 1.166L19.886 18c-.247 1.444-1.518 2.501-3.005 2.501H7.119c-1.487 0-2.758-1.057-3.005-2.501l-1.6-9.333A1.005 1.005 0 0 1 3.516 7.5H8zm2 0h4a2 2 0 1 0-4 0z",
    fill: "currentColor"
  }));
};

Bag.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
import iconHandler from './hoc';
export { Bag as icon };
export default iconHandler(Bag);